<template>
	<div v-if="displayDataEdit">
		<b-button
			v-if="!mode"
			v-b-toggle="className"
			block
			class="panel-item-header-button"
		>
			<div style="display: flex">
				<span class="panel-item-header-trigger-icon" />
				<span class="panel-item-header-title">
					<b> Service Provided </b>
					<br>
					{{ displayDataEdit.service || "No service name" }}
				</span>
			</div>
		</b-button>
		<div v-if="!mode">
			<b-collapse :id="className">
				<b-container>
					<b-row> 
						<b-col>
							<div>
								<div> 
									<b> Start Date </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									{{ displayDataEdit.startDate | formatDate }}
								</div>
							</div>
						</b-col>
						<b-col>
							<div>
								<div> 
									<b> End Date </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									{{ displayDataEdit.endDate | formatDate }}
								</div>
							</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row> 
						<b-col>
							<div>
								<div> 
									<b> Total Value </b>
								</div>
								<div style="text-align: right">
									<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
									${{ displayDataEdit.totalValue }}
								</div>
							</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>

					<b-row>
						<b-col>
							<b> Associated Phases </b>
						</b-col>
					</b-row>

					<b-row v-for="(phase, index) in displayDataEdit.associatedPhases" :key="index">
						<b-col>
							<div class="associated-phase">
								{{ phase }}
							</div>
						</b-col>
					</b-row>

					<b-row v-if="displayDataEdit.associatedPhases.length === 0">
						<b-col>No phases </b-col>
					</b-row>

					<b-row>
						<b-col>
							<b> Notes </b>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							{{ displayDataEdit.notes || "No notes" }}
						</b-col>
					</b-row>
				</b-container>
			</b-collapse>
		</div>
		<div v-if="mode">
			<b-container>
				<b-row> 
					<b-col>
						<label for="input-service">Service Provided</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-service"
							v-model="displayDataEdit.service"
							size="sm"
							placeholder="Enter service name"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-startdate">Start Date</label>
					</b-col>
					<b-col>
						<label for="input-enddate">End Date</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-datepicker
							:id="'input_startdate_' + index"
							v-model="displayDataEdit.startDate"
							size="sm" 
							locale="en" 
							placeholder="Choose a date"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
					<b-col>
						<b-form-datepicker
							:id="'input_enddate_' + index"
							v-model="displayDataEdit.endDate"
							size="sm" 
							locale="en" 
							placeholder="Choose a date"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-totalvalue">Total Value ($)</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-input
							id="input-totalvalue"
							v-model="displayDataEdit.totalValue"
							size="sm"
							type="number"
							placeholder="Enter total value"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="associated-phases">Associated Phases</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-checkbox-group
							:id="'checkbox_group_' + index"
							v-model="displayDataEdit.associatedPhases"
							:options="options"
							name="flavour-1"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						<label for="input-notes">Notes</label>
					</b-col>
				</b-row>
				<b-row> 
					<b-col>
						<b-form-textarea
							id="input-notes"
							v-model="displayDataEdit.notes"
							size="sm"
							placeholder="Enter notes"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<b-button block @click="remove()">
							Remove Service Agreement
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
export default {
    name: 'ServiceAgreementView',
	components: {},
    filters: {
		formatDate(date) {
			if (!date || date === '') return 'Not updated'
			return new Date(date).toISOString().slice(0, 10);
		}
	},
	props: {
        agreement: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
        mode: {
            type: Boolean,
            required: true
        }
	},   
    data() {
        return {
            className: '',
			editMode: false,
			displayDataEdit: {},
			options: [
				{ text: 'Planning', value: 'Planning' },
				{ text: 'Design', value: 'Design' },
				{ text: 'Construction', value: 'Construction' },
				{ text: 'Stabilization', value: 'Stabilization' },
				{ text: 'Steady-State', value: 'Steady-State' }
			]
        }
    },
    computed: {
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		agreement: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
        mode: {
			immediate: true,
			handler(newVal) {
				this.editMode = newVal;
			},
		},
        index: {
			immediate: true,
			handler(newVal) {
				this.className = `agreement_collapse_${newVal}`;
			},
		}
	},
	created() {
	},
    mounted() {
	},
    methods: {
        edit() {
			this.editMode = !this.editMode;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postServiceAgreementModelData = await this.axios.patch(
					`/serviceagreements/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		async remove() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postServiceAgreementModelData = await this.axios.delete(
					`/serviceagreements/${this.displayDataEdit.id}`
				);
			}
		}
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
    background-color: transparent;
}
.panel-item-header-title {
    bottom: 2px;
	font-family: "Proxima-Nova"; 
	font-size: 1rem;
	font-weight: 400;
}
div.associated-phase {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #647882;
    color: #ffffff;
}
</style>

<style lang="scss">
</style>